import styled, { css } from 'react-emotion';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { reduxForm, formValueSelector } from 'redux-form';
import validate from './validate';
import StepTitle from '../../../common/StepTitle';
import { EventSteps } from '../shared/EventSteps/EventSteps';
import ErrorRobot from '../../../common/ErrorRobot';

import { FFS_EMAIL_ADDRESS } from '../../../../constants/appConstants';
import { LOADING, AVAILABLE } from '../../../../constants/entityStatus';
import Loading from '../../../Loading';
import { withTranslation } from 'react-i18next';

const divStyle = css({
  marginBottom: '50px'
});

const Container = styled('div')`
  display: flex;
  height: 500px;
  flex-direction: column;
  align-items: center;
`;

const EventStepsTitle = styled('h3')`
  margin-top: 0;
  margin-bottom: 40px;
`;

const homePageButtonStyle = css({
  float: 'left'
});

const contractButtonStyle = css({
  float: 'right'
});

class ResultStep extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    contractStatus: PropTypes.string.isRequired,
    contract: PropTypes.object
  };

  componentDidMount() {
    this.props.reset();
  }

  renderContractButton = () => {
    const { contract, t } = this.props;

    return (
      <div className={contractButtonStyle}>
        <Link className="btn btn-primary" to={`/${contract.termId}/${contract.revisionId}`}>
          {t('createContract:result.viewContract')}
        </Link>
      </div>
    );
  };

  render() {
    const { contractStatus, handleSubmit, t } = this.props;

    const steps = [
      t('createContract:result.step_0'),
      t('createContract:result.step_1'),
      t('createContract:result.step_2')
    ];

    if (contractStatus === LOADING) {
      return <Loading />;
    }

    const successDisplay = (
      <Container>
        <StepTitle
          icon="finalize-contract-l"
          title={t('createContract:result.header')}
          description={t('createContract:result.description')}
          titleStyle="success"
        />
        <div>
          <EventStepsTitle>{t('createContract:result.whatHappensNext')}</EventStepsTitle>
          <EventSteps steps={steps} activeIndex={0} />
        </div>
      </Container>
    );

    const errorDisplay = (
      <ErrorRobot
        includeContact={false}
        msg={`${t('createContract:result.errorCreatingContractMessage', { contactEmailAddress: FFS_EMAIL_ADDRESS })}`}
      />
    );

    const display = contractStatus === AVAILABLE ? successDisplay : errorDisplay;

    const homePageButton = (
      <div className={homePageButtonStyle}>
        <Link className="btn btn-outline-primary" to="/">
          {t('createContract:result.backToHomePage')}
        </Link>
      </div>
    );

    const contractButton = contractStatus === AVAILABLE ? this.renderContractButton() : null;

    return (
      <form onSubmit={handleSubmit}>
        {display}
        <div className={divStyle}>
          {homePageButton}
          {contractButton}
        </div>
      </form>
    );
  }
}

function mapStateToProps(state) {
  const formSelector = formValueSelector('buyerCreateFlow');

  return {
    creationType: formSelector(state, 'creationType')
  };
}

ResultStep = connect(
  mapStateToProps,
  null
)(ResultStep);

export default reduxForm({
  form: 'buyerCreateFlow',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(withTranslation()(ResultStep));
